import gql from 'graphql-tag'

export const NAME = 'updateClientsOrganization'
const UPDATE_CLIENTS_ORGANIZATION_BY_USER_IDS = gql`
  mutation ${NAME}($ids: [ID!], $newOrgId: ID!) {
    ${NAME}(ids: $ids, newOrgId: $newOrgId)
  }
`
export default UPDATE_CLIENTS_ORGANIZATION_BY_USER_IDS
